import { AddContribution } from '../../components/Contributions';

const NewContribution = () => (
    <AddContribution />
);

export default NewContribution;
